module.exports = __webpack_public_path__ + "static/media/overgas-direct-logo-en.cc18c9be.png";